import { Button, Icon, Menu, MenuTrigger } from '@iconik-io/uad';

import {
  downloadCommentsCsv,
  downloadCommentsSrt,
  downloadCommentsText,
  downloadCommentsVtt,
} from '../../../../redux/comments/thunks';
import { useAppDispatch } from '../../../../redux/redux_hooks';

type CommentsMenuButtonProps = {
  assetId: string;
  currentVersionId: string;
  isDisabled?: boolean;
};

export function CommentsMenuButton(props: CommentsMenuButtonProps) {
  const { assetId, currentVersionId, isDisabled } = props;
  const dispatch = useAppDispatch();

  const transcriptionDownloadOptions = [
    {
      label: 'Download as Text',
      id: 'text',
      icon: 'load_down' as const,
      onPress: () => {
        dispatch(downloadCommentsText(assetId, currentVersionId));
      },
      isDisabled,
    },
    {
      label: 'Download as WebVTT',
      id: 'vtt',
      icon: 'load_down' as const,
      onPress: () => {
        dispatch(downloadCommentsVtt(assetId, currentVersionId));
      },
      isDisabled,
    },
    {
      label: 'Download as SRT',
      id: 'srt',
      icon: 'load_down' as const,
      onPress: () => {
        dispatch(downloadCommentsSrt(assetId, currentVersionId));
      },
      isDisabled,
    },
    {
      label: 'Download as CSV',
      id: 'csv',
      icon: 'load_down' as const,
      onPress: () => {
        dispatch(downloadCommentsCsv(assetId, currentVersionId));
      },
      isDisabled,
    },
  ];

  return (
    <MenuTrigger>
      <Button
        size="m"
        variant="tertiary"
        aria-label="More comment options"
        icon={<Icon name="menu_context" />}
      />
      <Menu
        popoverProps={{ placement: 'bottom end' }}
        items={transcriptionDownloadOptions}
        selectionMode="none"
      />
    </MenuTrigger>
  );
}
